export default "__VITE_ASSET__5lNi0sZv__"